import React, { createContext, useContext, useState } from 'react';

const LeadModalContext = createContext();

export const LeadModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [defaultProgram, setDefaultProgram] = useState('');
  const [courseData, setCourseData] = useState(null);

  const openModal = (program = '', course = null) => {
    setDefaultProgram(program);
    setCourseData(course);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setDefaultProgram('');
    setCourseData(null);
  };

  return (
    <LeadModalContext.Provider value={{ isOpen, defaultProgram, courseData, openModal, closeModal }}>
      {children}
    </LeadModalContext.Provider>
  );
};

export const useLeadModal = () => {
  const context = useContext(LeadModalContext);
  if (!context) {
    throw new Error('useLeadModal must be used within a LeadModalProvider');
  }
  return context;
};
